import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Modal, Button, ButtonGroup } from "react-bootstrap";
import "font-awesome/css/font-awesome.min.css";

const TabQRComponent = ({ group = "1,14", handleLogQREvent }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [config, setConfig] = useState("1");

  const jsonData = {
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_COMPONENT_NAME":
      "com.leadschool.hmdm/com.leadschool.hmdm.AdminReceiver",
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_DOWNLOAD_LOCATION":
      "https://ta-updates.leadschool.in/lead-prod-mdm-5.12.7(65).apk",
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_CHECKSUM":
      "gEzUF0cw0-QljDxyyf36Rs2Lif0BZ-scGClf6V5Pjcg=",
    "android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED": true,
    "android.app.extra.PROVISIONING_SKIP_ENCRYPTION": true,
    "android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE": {
      "com.hmdm.CONFIG": config,
      "com.hmdm.GROUP": group,
      "com.hmdm.BASE_URL": "http://mdm.leadschool.in",
      "com.hmdm.SERVER_PROJECT": "",
    },
  };

  const handleClick = (configId) => {
    setConfig(configId);
    setIsModalOpen(true);

    // firebase analytics event
    handleLogQREvent(configId, group);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const getModalTitle = () => {
    if (config === "1") {
      return "M7 Tab - QR Code";
    } else if (config === "10") {
      return "M8 Tab - QR Code";
    }

    return "QR Code";
  };

  return (
    <div style={{ textAlign: "right", paddingRight: "20px" }}>
      <ButtonGroup size="sm">
        <Button
          variant="light"
          onClick={() => {
            handleClick("1");
          }}
        >
          <i className="fa fa-qrcode" aria-hidden="true"></i> M7 Tab QR Code
        </Button>
        <Button
          variant="light"
          onClick={() => {
            handleClick("10");
          }}
        >
          <i className="fa fa-qrcode" aria-hidden="true"></i> M8 Tab QR Code
        </Button>
      </ButtonGroup>
      <Modal show={isModalOpen} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{getModalTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="qr-body-center">
          <QRCodeCanvas
            value={JSON.stringify(jsonData)}
            className="qr-content"
            size={360}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabQRComponent;
